import { Injectable } from '@angular/core';
import { RequestOptions, Response, URLSearchParams } from '@angular/http';

import { AuthHttp } from 'app/infrastructure/common/index';
import { AppSettings } from 'app/infrastructure/settings/index';

@Injectable()
export class ProductConfigService {
    constructor(private http: AuthHttp) { }

    getOwnerConfig(ownerCode: string) {
        let params: URLSearchParams = new URLSearchParams();
        params.set("ownerCode", ownerCode);

        let options: RequestOptions = new RequestOptions({ search: params });
        return this.http.get(AppSettings.apiEndpoint + "Product/GetOwnerConfig", options)
            .map((response: Response) => response.json());
    }

    getProductInventoryGridConfig(ownerCode: string) {
        let params: URLSearchParams = new URLSearchParams();
        params.set("ownerCode", ownerCode);

        let options: RequestOptions = new RequestOptions({ search: params });
        return this.http.get(AppSettings.apiEndpoint + "Product/GetProductInventoryGridConfig", options)
            .map((response: Response) => response.json());
    }
}


// WEBPACK FOOTER //
// ./src/app/infrastructure/services/master/wm/product-config.service.ts